import { useState, type FC } from "react";
import { Button, Tooltip } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { createPortal } from "react-dom";
import { useTranslation } from "react-i18next";
import { ReactComponent as FieldOperationsIcon } from "../../assets/images/list-btn-machinary.svg";
import { formatTranslation } from "../utils/translationUtils";

import { MachineryFieldOperationsComponent } from "./MachineryFieldOperations";
import { LayerOption } from "../../pages/new-trail/trialMapComponent/MapLayersDrawer";
interface MachineryButtonComponentProps {
  onOpen?: (layer: LayerOption) => void;
  onClose?: () => void;
  onClearSelection?: () => void;
  isSelected?: boolean;
}

const MachineryButtonComponent: FC<MachineryButtonComponentProps> = ({
  onOpen,
  onClose,
  onClearSelection,
  isSelected = false,
}) => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState<boolean>(false);
  const showDrawer = (): void => {
    setVisible(true);
    onOpen?.(LayerOption.Machinery);
  };
  const closeFieldOperationsDrawer = (): void => {
    setVisible(false);
    onClose?.();
  };
  return (
    <div>
      <div className="corner-btn">
        <Tooltip
          title={formatTranslation(t("machineryButton.title"))}
          placement="left"
        >
          <Button
            ghost={true}
            aria-label={formatTranslation(t("machineryButton.open"))}
            onClick={showDrawer}
            type="primary"
          >
            <FieldOperationsIcon className={isSelected ? "active" : ""} />
          </Button>
        </Tooltip>
        {visible && isSelected && (
          <Button
            aria-label={formatTranslation(t("machineryButton.close"))}
            className="close-button"
            onClick={(e) => {
              e.stopPropagation();
              closeFieldOperationsDrawer();
              onClose?.();
            }}
          >
            <CloseOutlined />
          </Button>
        )}
      </div>

      {/* adding a portal so that this component renders higher up the component and relatvie to the .map div */}
      {visible &&
        isSelected &&
        createPortal(
          <MachineryFieldOperationsComponent
            closeFieldOperationsDrawer={closeFieldOperationsDrawer}
          />,
          document.getElementById("trial-map") ?? document.body
        )}
    </div>
  );
};

export default MachineryButtonComponent;
